const {select, selectAll} = require("d3-selection");
const {min, max, maxIndex, extent, ticks} = require("d3-array");
const {scaleLinear, scaleBand} = require("d3-scale");
const {axisBottom, axisLeft} = require("d3-axis");
const {format} = require("d3-format");

module.exports = function (target) {
  const leading = 20;

  const svg = select(document.createElementNS("http://www.w3.org/2000/svg", "svg"))
    .attr("width", 0)
    .attr("height", 0);

  const y = scaleBand().paddingInner(0.3);
  const x = scaleLinear();

  const barGroup = svg.append("g");
  const yAxisLabelGroup = svg.append("g");
  const barLabelGroup = svg.append("g");

  const xAxisLabel = svg.append("text")
    .attr("class", "x-axis-label");

  target.appendChild(svg.node());

  return function join (ratios, leftMargin = 0, label = []) {
    const labelString = label.join(" ");
    const labelWidth = labelString.length * 8;

    y.domain(ratios.map(d => d.band));
    x.domain([0, max(ratios, d => d.ratio)]);

    const bars = barGroup
      .selectAll("rect")
      .data(ratios, d => d.band)
      .join("rect")
      .attr("class", d =>
        d.band === "user"
        ? "user-bar"
        : d.band === "average"
        ? "average-bar"
        : "bar"
      );

    const yAxisLabels = yAxisLabelGroup
      .selectAll("text")
      .data(ratios, d => d.band)
      .join("text")
      .attr("text-anchor", "start")
      .style("transform", d => `translate(0, ${((d.label.length - 1) * -leading / 2) - leading}px)`)
      .attr("dominant-baseline", "middle")
      .attr("class", d => d.band === "user" ? "axis-label-user" : "axis-label")
      .call(g => {
        g.selectAll("tspan")
          .data(d => d.label)
          .enter()
          .append("tspan")
          .text(d => d)
          .attr("dy", leading)
          .attr("x", 0);
      });

    const barLabels = barLabelGroup
      .selectAll("text")
      .data(ratios, d => d.band)
      .join("text")
      .attr("dominant-baseline", "middle")
      .attr("class", d => d.band === "user" ? "bar-label-user" : "bar-label")
      .text(d => Math.round(d.ratio));

    function update () {
      const width = target.offsetWidth;

      const margin = {};
      margin.right = 50;
      margin.bottom = 0;
      margin.left = leftMargin;
      margin.top = label.length ? 25 + (16 * (width > margin.left + labelWidth ? 1 : label.length)) : 0;

      const height = ratios.length * 50 + margin.top + margin.bottom;

      xAxisLabel.call(g => {
        g.selectAll("tspan")
          .data(width > margin.left + labelWidth
              ? [labelString]
              : label)
          .join("tspan")
          .text(d => d)
          .attr("dy", 16)
          .attr("x", margin.left);
      });

      svg
        .attr("width", width)
        .attr("height", height);

      x.rangeRound([0, width - margin.right - margin.left]);
      y.range([height - margin.bottom, margin.top]);

      bars.attr("y", d => y(d.band))
        .attr("height", y.bandwidth())
        .attr("x", d => margin.left)
        .attr("width", d => max([0, x(d.ratio)]));

      yAxisLabels
        .attr("x", margin.left)
        .attr("y", d => y(d.band) + y.bandwidth() / 2);

      barLabels
        .attr("x", d => margin.left + max([0, x(d.ratio)]) + 10)
        .attr("y", d => y(d.band) + y.bandwidth() / 2);
    };

    update();
    return update;
  }
}
